import React, { useEffect, useState } from 'react';
import Plot from "react-plotly.js";


const PPScatterPlot = ({ data, svgRef, onDownloadBtn }) => {

useEffect(()=> console.log(data),[])

  const config = {
    displayModeBar: false,
    staticPlot: true,
  };

  const layout = {
    xaxis: {
      range: [-100, 2600],
      title: 'geneset size', // x축의 이름
    },
    yaxis: {
      range: [0, 8.5],
      title: '-log(p-value)', // x축의 이름
    },
    width: 600,
    height: 550,
    legend: {
      yanchor: "bottom",
      y: -0.5,
      orientation: "v",
      xanchor: "center",
      x: 0.5,
      font: {
        size: 14.5,
        color: "black"
      }
    },
    margin: { l: 40, t: 30 },
  };


  return (
    <div>
      <p style={{ margin: ' 10px auto', textAlign: 'center' }}>
        Figure. Scatter plot
        {/* <span style={{
          margin: '0px 6px',
          padding: '3px 8px',
          borderRadius: '4px',
          color: 'white',
          cursor: 'pointer',
          backgroundColor: '#0bbf7a'
        }}
          onClick={onDownloadBtn}
        >download</span> */}
      </p>
      <div ref={svgRef}>
        <Plot
          data={data}
          layout={layout}
          config={config}
        />
      </div>
    </div>
  );
};

export default PPScatterPlot;
